import { createTheme } from '@mui/material';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import stylisRTLPlugin from 'stylis-plugin-rtl';

export const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'IRANYekan',
  },
  palette: {
    primary: {
      main: '#1565c0',
      contrastText: 'white',
    },
    secondary: {
      main: '#FFBF00',
      contrastText: 'white',
    },
  },
});
export const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, stylisRTLPlugin],
});
